/** @module Media queries in React: which layout and how much motion the screen wants. */
import { useSyncExternalStore } from "react";

function subscribe(query: string) {
  return (notify: () => void) => {
    if (typeof window.matchMedia !== "function") return () => undefined;
    const list = window.matchMedia(query);
    list.addEventListener("change", notify);
    return () => {
      list.removeEventListener("change", notify);
    };
  };
}

/** True while the query matches; false where the browser cannot tell (tests, old engines). */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(subscribe(query), () =>
    typeof window.matchMedia === "function" ? window.matchMedia(query).matches : false,
  );
}

/** The desktop layout from Tailwind's `lg` breakpoint on. */
export const WIDE = "(min-width: 1024px)";
